export enum EmailStudioMode {
  Draft = 'draft',
  AutoSend = 'auto-send',
}
